// 24 Oct 2026 (Nas, page weight): moved out of snippets/adore-fb-sizes.liquid so the browser can cache it. Code unchanged.
(function(){
  var box=null;
  function pills(){ return [].filter.call(document.querySelectorAll('.product-page-info__options [data-js-option-value]'),function(p){ return p.querySelector('.adsz'); }); }
  /* the theme's size buttons ignore a bare el.click(); a full mouse click event switches the size like a real tap */
  function tap(el){ el.dispatchEvent(new MouseEvent('click',{bubbles:true,cancelable:true,view:window})); }
  function close(){ if(box) box.classList.remove('is-open'); var b=document.querySelector('.adore-fb-size'); if(b) b.setAttribute('aria-expanded','false'); }
  function open(btn){
    var ps=pills(); if(!ps.length) return false;
    if(!box){ box=document.createElement('div'); box.className='afs'; box.setAttribute('role','dialog'); box.setAttribute('aria-label','Choose a size'); document.body.appendChild(box); }
    var ins=ps.filter(function(p){ return !p.classList.contains('disabled'); });
    var outN=ps.length-ins.length;
    ins.sort(function(a,b){ return (parseInt(a.style.order,10)||0)-(parseInt(b.style.order,10)||0); });
    var h='<div class="afs__head"><span>Choose a size</span><button type="button" class="afs__x" aria-label="Close">&times;</button></div>';
    ins.forEach(function(p,i){
      var pp=p.querySelector('.adore-pp');
      h+='<button type="button" class="afs__opt'+(p.classList.contains('active')?' is-on':'')+'" data-afs="'+i+'"><span>'+p.querySelector('.adsz').textContent+'</span><span class="afs__p">'+(pp?pp.innerHTML:'')+'</span></button>';
    });
    if(outN) h+='<div class="afs__out">'+outN+' more '+(outN===1?'size':'sizes')+' sold out</div>';
    box.innerHTML=h;
    box.querySelector('.afs__x').addEventListener('click',close);
    [].forEach.call(box.querySelectorAll('[data-afs]'),function(o){ o.addEventListener('click',function(){ var p=ins[+o.getAttribute('data-afs')]; close(); if(p && !p.classList.contains('active')) tap(p); }); });
    box.classList.add('is-open'); btn.setAttribute('aria-expanded','true');
    return true;
  }
  /* caught before the older handler in adore-pdp-extras, which scrolled the page to the size buttons */
  document.addEventListener('click',function(e){
    var t=e.target, btn=t && t.closest ? t.closest('.adore-fb-size') : null;
    if(btn){
      if(box && box.classList.contains('is-open')){ e.preventDefault(); e.stopPropagation(); close(); return; }
      if(open(btn)){ e.preventDefault(); e.stopPropagation(); }
      return;
    }
    if(box && box.classList.contains('is-open') && !box.contains(t)) close();
  },true);
  document.addEventListener('keydown',function(e){ if(e.key==='Escape') close(); });
  /* the list belongs to the bar: close it when the bar hides */
  window.addEventListener('scroll',function(){ if(box && box.classList.contains('is-open') && document.documentElement.classList.contains('adore-fb-hold')) close(); },{passive:true});
})();
